import {NullableNumber} from "../../../../../common/types/nullable-types";
import { computed, makeObservable } from "mobx";
import {ApplyGameFilterResult} from "../../evaluators/game-filter-evaluator.interface";
import {ArenaGameFilterBase} from "./arena-game-filter-base";
import {GameInfo} from "../../../games/game-info";
import {IArenaGameFilter} from "./arena-game-filter.interface";
import {IGameFilterDefinition} from "../../filters-definitions/game-filter-definition.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";

export class DynamicArenaGameFilter extends ArenaGameFilterBase {
    constructor(filterDefinition: IGameFilterDefinition,
                services: IServiceFactoryExtended) {
        super(filterDefinition, services);

        makeObservable(this);
    }

    @computed
    get games(): GameInfo[] {
        const currentArenaGames = this.services.arenas.getCurrentArena().allArenaGamesForFiltering;
        return  currentArenaGames.filter(gameInfo => this.filterDefinition.applyFilter(gameInfo) === ApplyGameFilterResult.IncludeGame)
    }

    get gamesCount(): NullableNumber {
        return this.games.length;
    }

    @computed
    get subFilters(): IArenaGameFilter[] {
        return this.filterDefinition.subFilters.map(sf => new DynamicArenaGameFilter(sf, this.services))
                                               .filter(f => f.gamesCount > 0)
                                               .sort((f1, f2) => f2.gamesCount - f1.gamesCount);
    }
}